// extracted by mini-css-extract-plugin
export default {"emptyItem":"dropContent_emptyItem__B4pV3"};